// extracted by mini-css-extract-plugin
module.exports = {"mainImage":"styles_mainImage__2cB-R","title":"styles_title__rY8FW","info":"styles_info__1phKG"};